<nova-icon-registry />
<header class="header">
  <div class="header-left">
    <img
      src="assets/logos/rocketclose-clearsign-logo.svg"
      [alt]="'shell.LOGO_ALT_TEXT' | translate"
      class="logo"
    />
  </div>
  <div class="header-right">
    <div novaDropdown #langDropdown="novaDropdown">
      <button
        novaButton
        novaDropdownTrigger
        variant="tertiary"
        aria-haspopup="listbox"
        [attr.aria-expanded]="langDropdown.isOpen()"
        [attr.aria-label]="'shell.LANGUAGE_SELECTOR_TITLE' | translate"
        [title]="'shell.LANGUAGE_SELECTOR_TITLE' | translate"
        (keydown)="onTriggerKeydown($event)"
      >
        <nova-icon
          class="nova-button__icon-left"
          name="language"
          [title]="'shell.LANGUAGE_SELECTOR_TITLE' | translate"
        />
        <span>{{ languageService.currentLanguageDetails().code.toUpperCase() }}</span>
      </button>
      <nova-dropdown-content size="small" align="end">
        @for (language of languageService.availableLanguages; track language.code) {
          <button
            #langItem
            novaDropdownItem
            tabindex="0"
            [title]="'shell.LANGUAGE_SELECT_TITLE' | translate: { languageName: language.name }"
            [attr.aria-current]="language.code === languageService.currentLanguage() ? 'true' : null"
            (click)="selectLanguage(language.code)"
            (keydown)="onItemKeydown($event, language.code)"
            class="language-option"
          >
            <span>{{ language.name }}</span>
            @if (language.code === languageService.currentLanguage()) {
              <span class="language-check" aria-hidden="true">&#x2713;</span>
            }
          </button>
        }
      </nova-dropdown-content>
    </div>
    <a
      novaButton
      variant="tertiary"
      class="call-support"
      href="tel:+18449131386"
      [attr.aria-label]="'shell.CALL_SUPPORT_TITLE' | translate"
      [title]="'shell.CALL_SUPPORT_TITLE' | translate"
    >
      {{ phoneNumber }}
      <nova-icon
        class="nova-button__icon-right"
        name="phone_in_talk"
        [title]="'shell.CALL_SUPPORT_TITLE' | translate"
      />
    </a>
  </div>
</header>
<main class="content">
  <ng-content />
</main>
@if (!hideFooter()) {
  @if (useCompactFooter()) {
    <app-compact-footer />
  } @else {
    <app-footer />
  }
}
